export default __webpack_public_path__ + "static/mtp-d25caa95a2c738dbcb0883e95bf3b596.svg";